import { copyToClipboard } from './copyToClipBoard';

/**
 * 공유하기 기능을 위한 함수들이 정의된 파일입니다.
 */
export const share = (data: ShareData) => {
  return new Promise<'shared' | 'copiedToClipboard' | 'failed'>(async resolve => {
    // 안드로이드 웹뷰에서는 share가 존재하징 않음
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, @typescript-eslint/strict-boolean-expressions
    if (!!navigator?.share) {
      await navigator.share(data);
      resolve('shared');
      return 'shared';
    }

    if (data.url) {
      const result = await copyToClipboard(data.url);

      if (result) {
        resolve('copiedToClipboard');
        return 'copiedToClipboard';
      }
    }
    resolve('failed');
    return 'failed';
  });
};
